import { WSEmptyState } from "@wingspanhq/fe-component-library";

/**
 * The Flatfile upload job died before finishing, which leaves the batch with only a part of the
 * spreadsheet rows and no way to complete the upload.
 */
export const BulkBatchUploadFailedAlert: React.FC = () => (
  <WSEmptyState
    orientation="horizontal"
    data-testid="uploadFailed"
    type="noInternetConnection"
    hasBorder={false}
    title="This upload could not be completed"
    description={
      <>
        A server error stopped this upload before it finished, so the file was
        only partly uploaded.
        <br />
        Our team has been notified automatically.
        <br />
        <br />
        Contact support before starting a new upload.
      </>
    }
  />
);
